<div class="sovos-callback">
  <p>Processing SOVOS callback, please wait...</p>
</div>
